'use client';

import React from 'react';
import AlbumCard from '@/components/AlbumCard';
import { getThumbnailUrl } from '@/lib/thumbnail';
import { Album } from '@/types/interface';

interface AlbumGridProps {
	albums: Album[];
	isFeatured?: boolean;
}

const AlbumGrid: React.FC<AlbumGridProps> = ({ albums, isFeatured = false }) => {
	return (
		<div
			className={`grid gap-10 ${isFeatured
					? 'grid-cols-1 md:grid-cols-2'
					: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5'
				}`}
		>
			{albums.map((album) => {
				const coverPhoto = album.photos.find((photo) => photo.isCover) || album.photos[0];
				return (
					<div key={album.id}>
						{coverPhoto && (
							<AlbumCard
								id={album.id}
								title={album.title}
								coverPhoto={getThumbnailUrl(coverPhoto)}
								isFeatured={isFeatured}
							/>
						)}
					</div>
				);
			})}
		</div>
	);
};

export default AlbumGrid;
